import { Components, Theme } from '@mui/material/styles';
// Shared InputLabel/OutlinedInput overrides style both TextField and Select.
export const MuiTextField: Components<Theme>['MuiTextField'] = {
  defaultProps: { variant: 'outlined' },
};
